import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Magnify Plus Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-magnify-plus-outline',
    templateUrl: './icon-magnify-plus-outline.component.html',
    styleUrls: ['./icon-magnify-plus-outline.component.scss'],
    standalone: false
})
export class IconMagnifyPlusOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
